const estimateCredits = (activity) =>
  activity.credite_acordate ||
  Math.max(1, Math.ceil((Number(activity.credite_per_ora) || 1) * (activity.ore_recomandate || 1)));

export const knowledgeScores = (dataset, profiles, studentId) => {
  const profile = profiles.get(studentId);
  if (!profile) return new Map();
  if ((dataset.targetSum || 0) <= 0) return new Map();

  if (profile.totalCredits >= dataset.targetSum || (profile.rolloverCredits || 0) >= dataset.targetSum) {
    const scores = new Map();
    dataset.activities.forEach((activity) => {
      scores.set(activity.id, {
        activityId: activity.id,
        score: 0.3,
        rule: 'enrichment',
        enrichment: true,
        deficit: 0,
        moduleId: activity.id_module,
        moduleCode: dataset.moduleById.get(activity.id_module)?.cod_module,
        rolloverCredits: profile.rolloverCredits || 0,
        totalCredits: profile.totalCredits,
        targetSum: dataset.targetSum,
      });
    });
    return scores;
  }

  const rolloverCredits = profile.rolloverCredits || 0;
  const remainingTarget = Math.max(0, dataset.targetSum - rolloverCredits);
  const moduleCount = dataset.modules.length || 1;
  const perModuleTarget = remainingTarget / moduleCount;

  const scores = new Map();
  let sequenceAssigned = false;

  dataset.modules.forEach((module) => {
    const credits = profile.creditsByModule[module.cod_module] || 0;
    const deficit = Math.max(0, perModuleTarget - credits);
    if (deficit <= 0) return;

    const isSequence = !sequenceAssigned;
    dataset.activities
      .filter((activity) => activity.id_module === module.id)
      .forEach((activity) => {
        const estimated = estimateCredits(activity);
        const base = Math.min(1, estimated / deficit);
        const score = isSequence ? Math.min(1, base + 0.15) : base;
        const current = scores.get(activity.id);
        if (!current || current.score < score) {
          scores.set(activity.id, {
            activityId: activity.id,
            score,
            rule: isSequence ? 'sequence' : 'gap',
            deficit: Math.ceil(deficit),
            targetPerModule: Math.round(perModuleTarget * 10) / 10,
            moduleId: module.id,
            moduleCode: module.cod_module,
            rolloverCredits,
            totalCredits: profile.totalCredits,
            targetSum: dataset.targetSum,
          });
        }
      });

    sequenceAssigned = true;
  });

  return scores;
};
